import { BoxProps } from '@mui/material';
import theme from 'config/material-ui/theme';
import { ScheduleWorkingDay } from './generateScheduleWorkingDays';

interface GetDayThemeProps {
  scheduleWorkingDay: ScheduleWorkingDay;
  primary: boolean;
}

interface GetDayThemeReturn {
  wrapper: {
    borderColor: BoxProps['borderColor'];
    background: BoxProps['bgcolor'];
  };
  range: {
    backgroundColor: BoxProps['bgcolor'];
  };
}

export default function getDayTheme({
  scheduleWorkingDay,
  primary,
}: GetDayThemeProps): GetDayThemeReturn {
  const hasRanges = !!scheduleWorkingDay.ranges.length;
  const getBackgroundWrapper = () => {
    if (!hasRanges) {
      return theme.palette.gradients.grayDiagonalStripes;
    }

    return primary ? theme.palette.blue[50] : theme.palette.background.other;
  };

  return {
    wrapper: {
      borderColor: primary && hasRanges ? 'blue.100' : 'background.accordion',
      background: getBackgroundWrapper(),
    },
    range: {
      backgroundColor: primary ? 'primary.main' : 'icon.light',
    },
  };
}
